import type { OutlookSpaceAsset, TimeStreamAsset } from 'owa-timestream-types';
import { owaDate } from 'owa-datetime';
import isPayloadEqual from '../../utils/isPayloadEqual';

export default function updateAsset(asset: TimeStreamAsset, outlookSpaceAsset: OutlookSpaceAsset) {
    const { dueDate, dueDateTz } = outlookSpaceAsset;

    asset.outlookSpaceAssetId = outlookSpaceAsset.id;
    asset.outlookSpaceAssetKey = outlookSpaceAsset.key;
    asset.type = outlookSpaceAsset.type;
    asset.bounds.x = outlookSpaceAsset.x;
    asset.bounds.y = outlookSpaceAsset.y;
    asset.bounds.width = outlookSpaceAsset.width || 0;
    asset.bounds.height = outlookSpaceAsset.height || 0;
    asset.createdDateTime = outlookSpaceAsset.createdDateTime;
    asset.lastModifiedDateTime = outlookSpaceAsset.lastModifiedDateTime;
    asset.isCaptured = !!outlookSpaceAsset.isCaptured;
    asset.parentId = outlookSpaceAsset.parentId;
    asset.order = outlookSpaceAsset.order;
    asset.dueDate = dueDateTz && dueDate ? owaDate(dueDateTz, dueDate) : undefined;
    asset.isComplete = outlookSpaceAsset.isComplete;
    asset.taskId = outlookSpaceAsset.taskId;
    asset.color = outlookSpaceAsset.color;

    if (!isPayloadEqual(asset.payload, outlookSpaceAsset.payload)) {
        asset.payload = outlookSpaceAsset.payload;
    }

    return asset;
}
